module.exports = __webpack_public_path__ + "img/ascend_gold36.63432f09.png";